import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(-0.65),
    //minWidth: 110,
  },
  iconForm: {
    spacing: 4,
    paddingLeft: 6,
    fontSize: 16,
  },
}));

function ApproachCheckbox(props) {
  const [checked, setChecked] = React.useState(props.checkedVal);
  const classes = useStyles();

  const handleChange = (event) => {
    if (!props.blocked) {
      setChecked(event.target.checked);
      props.handler(event, props.approachVal, props.group);
    }
  };

  return (
    <div>
      <FormControlLabel
        className={classes.formControl}
        //labelPlacement="start"

        control={
          <Checkbox
            checked={checked}
            disabled={props.disabled}
            //onChange={(e)=>setChecked(e.target.checked)}
            onChange={handleChange}
            onClick={(event) => event.stopPropagation()}
            onFocus={(event) => event.stopPropagation()}
            className={classes.formControl}
            inputProps={{
              "aria-label": "secondary checkbox",
            }}
            p={2}
          />
        }
        label={props.nameVal}
      />
    </div>
  );
}

export default ApproachCheckbox;
